import { useParams } from "react-router-dom";
import { useCommand } from "../hooks/commands.hooks";
import { useFile } from "../hooks/file.hooks";

const OrdersDocumentPreviewPage = () => {
	const { id } = useParams();
	const { data: command } = useCommand(id ?? null);
	const { data: file } = useFile({
		id: command?.purchaseOrderFileId ?? null,
	});

	if (file) {
		window.location.href = file.url;
		return null;
	}
	return null;
};

export default OrdersDocumentPreviewPage;
